/**
 * Created by lu on 2018/4/8.
 */

var nb = require('./nb');
var app = require('./app');
var Page = nb.define({
        parent: app.Page,
        view: {
            'class': 'nb-page',
            $html: [{
                'class': 'nb-page-header',
                $type: require('./view/Header'),
                $model: 'header'
            }, {
                'class': 'nb-page-content',
                $slot: 'content'
            }, {
                'class': 'nb-page-footer',
                $type: require('./view/Footer'),
                $model: 'footer'
            }, {
                'class': ['content-cover', nb.bind('dataReady')],
                $html: {
                    'class': 'content-loading abs-center',
                    $html: {
                        tag: 'img',
                        src: './image/loading.gif'
                    }
                }
            }, {
                'class': ['content-cover opacity0 ', nb.bind('ajaxReady')]
            }]
        }
    })
;
module.exports = Page;


//////////////////
// WEBPACK FOOTER
// ../src/js/Page.js
// module id = 61
// module chunks = 5 6 17 24 31 33 37 38